module.exports = __webpack_public_path__ + "img/位图(13).643f6cf2.png";